import "./MainPanel.scss";
import Logo from "../../Assets/svg/protika-fa 2.svg";
import WalletSVG from "../../Assets/svg/wallet-icon.svg";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useAuth from "../../hooks/Auth";
import Swal from "sweetalert2";

const Sidebar = ({ open, setOpen, type }) => {
  const sideClasses = open ? "panel-sidebar show-sidebar" : "panel-sidebar";
  const navigate = useNavigate();
  const { setAuth } = useAuth();

  function logoutUserHandler() {
    Swal.fire({
      title: "خروج ",
      text: `آیا میخواهید از سامانه خارج شوید؟`,
      // icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#40b2aa",
      cancelButtonColor: "#ee6900",
      confirmButtonText: "تایید",
      cancelButtonText: "انصراف",
    }).then((result) => {
      if (result.isConfirmed) {
        setAuth("");
        localStorage.removeItem("tokens");
        setTimeout(() => {
          navigate("/login");
        }, 2000);
      }
    });
  }
  return (
    <div className={sideClasses}>
      <ul>
        <div className="panel-logo">
          <img src={Logo} alt />
        </div>
        <div className="panel-logo-lg">
          <img src={Logo} alt />
        </div>
        <div className="panel-logo-sm">{/* <img src={logoSm} /> */}</div>
        <>
          <li>
            <NavLink
              to={"/user"}
              state={{ title: "پروفایل" }}
              onClick={() => setOpen(!open)}
            >
              <span className="icon">
                <svg
                  className="default-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 16.25H15C14.59 16.25 14.25 15.91 14.25 15.5C14.25 15.09 14.59 14.75 15 14.75H21C21.41 14.75 21.75 15.09 21.75 15.5C21.75 15.91 21.41 16.25 21 16.25Z"
                    fill="white"
                  />
                  <path
                    d="M21 20.25H15C14.59 20.25 14.25 19.91 14.25 19.5C14.25 19.09 14.59 18.75 15 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z"
                    fill="white"
                  />
                  <path
                    d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
                    fill="white"
                  />
                  <path
                    d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
                    fill="white"
                  />
                  <path
                    d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
                    fill="white"
                  />
                </svg>
                <svg
                  className="active-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 16.25H15C14.59 16.25 14.25 15.91 14.25 15.5C14.25 15.09 14.59 14.75 15 14.75H21C21.41 14.75 21.75 15.09 21.75 15.5C21.75 15.91 21.41 16.25 21 16.25Z"
                    fill="white"
                  />
                  <path
                    d="M21 20.25H15C14.59 20.25 14.25 19.91 14.25 19.5C14.25 19.09 14.59 18.75 15 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z"
                    fill="white"
                  />
                  <path
                    d="M22 8.52V3.98C22 2.57 21.36 2 19.77 2H15.73C14.14 2 13.5 2.57 13.5 3.98V8.51C13.5 9.93 14.14 10.49 15.73 10.49H19.77C21.36 10.5 22 9.93 22 8.52Z"
                    fill="white"
                  />
                  <path
                    d="M10.5 8.52V3.98C10.5 2.57 9.86 2 8.27 2H4.23C2.64 2 2 2.57 2 3.98V8.51C2 9.93 2.64 10.49 4.23 10.49H8.27C9.86 10.5 10.5 9.93 10.5 8.52Z"
                    fill="white"
                  />
                  <path
                    d="M10.5 19.77V15.73C10.5 14.14 9.86 13.5 8.27 13.5H4.23C2.64 13.5 2 14.14 2 15.73V19.77C2 21.36 2.64 22 4.23 22H8.27C9.86 22 10.5 21.36 10.5 19.77Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span className="side-caption">داشبورد</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to={"/userInformation"}
              state={{ title: "اطلاعات کاربری" }}
              onClick={() => setOpen(!open)}
            >
              <span className="icon">
                <svg
                  className="default-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19 3.29 20.93 5.56 21.66C6.22 21.89 6.98 22 7.81 22H16.19C17.02 22 17.78 21.89 18.44 21.66C20.71 20.93 22 19 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM20.5 16.19C20.5 18.33 19.66 19.68 17.97 20.24C17 18.33 14.7 16.97 12 16.97C9.3 16.97 7.01 18.32 6.03 20.24H6.02C4.35 19.7 3.5 18.34 3.5 16.2V7.81C3.5 4.99 4.99 3.5 7.81 3.5H16.19C19.01 3.5 20.5 4.99 20.5 7.81V16.19Z"
                    fill="white"
                  />
                  <path
                    d="M12.0019 8C10.0219 8 8.42188 9.6 8.42188 11.58C8.42188 13.56 10.0219 15.17 12.0019 15.17C13.9819 15.17 15.5819 13.56 15.5819 11.58C15.5819 9.6 13.9819 8 12.0019 8Z"
                    fill="white"
                  />
                </svg>
                <svg
                  className="active-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19 3.29 20.93 5.56 21.66C6.22 21.89 6.98 22 7.81 22H16.19C17.02 22 17.78 21.89 18.44 21.66C20.71 20.93 22 19 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM20.5 16.19C20.5 18.33 19.66 19.68 17.97 20.24C17 18.33 14.7 16.97 12 16.97C9.3 16.97 7.01 18.32 6.03 20.24H6.02C4.35 19.7 3.5 18.34 3.5 16.2V7.81C3.5 4.99 4.99 3.5 7.81 3.5H16.19C19.01 3.5 20.5 4.99 20.5 7.81V16.19Z"
                    fill="white"
                  />
                  <path
                    d="M12.0019 8C10.0219 8 8.42188 9.6 8.42188 11.58C8.42188 13.56 10.0219 15.17 12.0019 15.17C13.9819 15.17 15.5819 13.56 15.5819 11.58C15.5819 9.6 13.9819 8 12.0019 8Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span className="side-caption">اطلاعات کاربری</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to={"/orders"}
              state={{ title: "سفارشات" }}
              onClick={() => setOpen(!open)}
            >
              <span className="icon">
                <svg
                  className="default-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3 12.2305H17.82C16.84 12.2305 15.97 12.7705 15.53 13.6505L14.69 15.3105C14.49 15.7105 14.09 15.9605 13.65 15.9605H10.37C10.06 15.9605 9.62 15.8905 9.33 15.3105L8.49 13.6605C8.05 12.7905 7.17 12.2405 6.2 12.2405H2.7C2.31 12.2405 2 12.5505 2 12.9405V16.2005C2 19.8305 4.18 22.0005 7.82 22.0005H16.2C19.63 22.0005 21.74 20.1205 22 16.7805V12.9305C22 12.5505 21.69 12.2305 21.3 12.2305Z"
                    fill="white"
                  />
                  <path
                    d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V10.85C2.22 10.77 2.46 10.73 2.7 10.73H6.2C7.75 10.73 9.14 11.59 9.83 12.98L10.58 14.45H13.44L14.19 12.97C14.88 11.59 16.27 10.73 17.82 10.73H21.3C21.54 10.73 21.78 10.77 22 10.85V7.81C22 4.17 19.83 2 16.19 2ZM10.45 5.41H13.55C13.93 5.41 14.25 5.72 14.25 6.1C14.25 6.49 13.93 6.8 13.55 6.8H10.45C10.07 6.8 9.75 6.49 9.75 6.1C9.75 5.72 10.07 5.41 10.45 5.41ZM14.33 9.59H9.67C9.29 9.59 8.98 9.28 8.98 8.9C8.98 8.51 9.29 8.2 9.67 8.2H14.33C14.71 8.2 15.02 8.51 15.02 8.9C15.02 9.28 14.71 9.59 14.33 9.59Z"
                    fill="white"
                  />
                </svg>
                <svg
                  className="active-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.3 12.2305H17.82C16.84 12.2305 15.97 12.7705 15.53 13.6505L14.69 15.3105C14.49 15.7105 14.09 15.9605 13.65 15.9605H10.37C10.06 15.9605 9.62 15.8905 9.33 15.3105L8.49 13.6605C8.05 12.7905 7.17 12.2405 6.2 12.2405H2.7C2.31 12.2405 2 12.5505 2 12.9405V16.2005C2 19.8305 4.18 22.0005 7.82 22.0005H16.2C19.63 22.0005 21.74 20.1205 22 16.7805V12.9305C22 12.5505 21.69 12.2305 21.3 12.2305Z"
                    fill="white"
                  />
                  <path
                    d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V10.85C2.22 10.77 2.46 10.73 2.7 10.73H6.2C7.75 10.73 9.14 11.59 9.83 12.98L10.58 14.45H13.44L14.19 12.97C14.88 11.59 16.27 10.73 17.82 10.73H21.3C21.54 10.73 21.78 10.77 22 10.85V7.81C22 4.17 19.83 2 16.19 2ZM10.45 5.41H13.55C13.93 5.41 14.25 5.72 14.25 6.1C14.25 6.49 13.93 6.8 13.55 6.8H10.45C10.07 6.8 9.75 6.49 9.75 6.1C9.75 5.72 10.07 5.41 10.45 5.41ZM14.33 9.59H9.67C9.29 9.59 8.98 9.28 8.98 8.9C8.98 8.51 9.29 8.2 9.67 8.2H14.33C14.71 8.2 15.02 8.51 15.02 8.9C15.02 9.28 14.71 9.59 14.33 9.59Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span className="side-caption">سفارشات</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to={"/address"}
              state={{ title: "آدرس ها" }}
              onClick={() => setOpen(!open)}
            >
              <span className="icon">
                <svg
                  className="default-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.6211 8.45C19.5711 3.83 15.5411 1.75 12.0011 1.75C12.0011 1.75 12.0011 1.75 11.9911 1.75C8.46107 1.75 4.42107 3.82 3.37107 8.44C2.20107 13.6 5.36107 17.97 8.22107 20.72C9.28107 21.74 10.6411 22.25 12.0011 22.25C13.3611 22.25 14.7211 21.74 15.7711 20.72C18.6311 17.97 21.7911 13.61 20.6211 8.45ZM12.0011 13.46C10.2611 13.46 8.85107 12.05 8.85107 10.31C8.85107 8.57 10.2611 7.16 12.0011 7.16C13.7411 7.16 15.1511 8.57 15.1511 10.31C15.1511 12.05 13.7411 13.46 12.0011 13.46Z"
                    fill="white"
                  />
                </svg>
                <svg
                  className="active-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.6211 8.45C19.5711 3.83 15.5411 1.75 12.0011 1.75C12.0011 1.75 12.0011 1.75 11.9911 1.75C8.46107 1.75 4.42107 3.82 3.37107 8.44C2.20107 13.6 5.36107 17.97 8.22107 20.72C9.28107 21.74 10.6411 22.25 12.0011 22.25C13.3611 22.25 14.7211 21.74 15.7711 20.72C18.6311 17.97 21.7911 13.61 20.6211 8.45ZM12.0011 13.46C10.2611 13.46 8.85107 12.05 8.85107 10.31C8.85107 8.57 10.2611 7.16 12.0011 7.16C13.7411 7.16 15.1511 8.57 15.1511 10.31C15.1511 12.05 13.7411 13.46 12.0011 13.46Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span className="side-caption">آدرس ها</span>
            </NavLink>
          </li>

          {/* wallet */}
          <li>
            <NavLink
              to={"/wallet/charge"}
              state={{ title: "شارژ کیف پول" }}
              onClick={() => setOpen(!open)}
            >
              <span className="icon">
                <img src={WalletSVG} alt="شارژ کیف پول" />
              </span>

              <span className="side-caption">شارژ کیف پول</span>
            </NavLink>
          </li>

          <li onClick={logoutUserHandler}>
            <a onClick={() => setOpen(!open)}>
              <span className="icon">
                <svg
                  className="default-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.87828 12.07C7.87828 11.66 8.21828 11.32 8.62828 11.32H14.1083V2.86C14.0983 2.38 13.7183 2 13.2383 2C7.34828 2 3.23828 6.11 3.23828 12C3.23828 17.89 7.34828 22 13.2383 22C13.7083 22 14.0983 21.62 14.0983 21.14V12.81H8.62828C8.20828 12.82 7.87828 12.48 7.87828 12.07Z"
                    fill="white"
                  />
                  <path
                    d="M20.5416 11.5402L17.7016 8.69016C17.4116 8.40016 16.9316 8.40016 16.6416 8.69016C16.3516 8.98016 16.3516 9.46016 16.6416 9.75016L18.2016 11.3102H14.1016V12.8102H18.1916L16.6316 14.3702C16.3416 14.6602 16.3416 15.1402 16.6316 15.4302C16.7816 15.5802 16.9716 15.6502 17.1616 15.6502C17.3516 15.6502 17.5416 15.5802 17.6916 15.4302L20.5316 12.5802C20.8316 12.3002 20.8316 11.8302 20.5416 11.5402Z"
                    fill="white"
                  />
                </svg>
                <svg
                  className="active-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.87828 12.07C7.87828 11.66 8.21828 11.32 8.62828 11.32H14.1083V2.86C14.0983 2.38 13.7183 2 13.2383 2C7.34828 2 3.23828 6.11 3.23828 12C3.23828 17.89 7.34828 22 13.2383 22C13.7083 22 14.0983 21.62 14.0983 21.14V12.81H8.62828C8.20828 12.82 7.87828 12.48 7.87828 12.07Z"
                    fill="white"
                  />
                  <path
                    d="M20.5416 11.5402L17.7016 8.69016C17.4116 8.40016 16.9316 8.40016 16.6416 8.69016C16.3516 8.98016 16.3516 9.46016 16.6416 9.75016L18.2016 11.3102H14.1016V12.8102H18.1916L16.6316 14.3702C16.3416 14.6602 16.3416 15.1402 16.6316 15.4302C16.7816 15.5802 16.9716 15.6502 17.1616 15.6502C17.3516 15.6502 17.5416 15.5802 17.6916 15.4302L20.5316 12.5802C20.8316 12.3002 20.8316 11.8302 20.5416 11.5402Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span className="side-caption"> خروج </span>
            </a>
          </li>
        </>
      </ul>
    </div>
  );
};

export default Sidebar;
